<div class="risk-matrix">
    <!--div>
        <h2 ng-click="$ctrl.show = !$ctrl.show">{{'risk.matrix'|translate}}<i class="fa section-toggle fa-angle-down"></i></h2>
    </div-->
    <table ng-show="$ctrl.show">
        <tr ng-repeat="row in $ctrl.matrix track by $index">
            <td rowspan="{{$ctrl.config.ProbabilityMax - $ctrl.config.ProbabilityMin + 1}}" ng-if="$first" class="left-header" ng-bind-html="'matrix.Probability'|translate"></td>
            <th>{{row[0].probability}}</th>
            <td ng-repeat="classification in row track by $index" ng-click="$ctrl.onClick(classification)" ng-class="{'{{classification.color}}':true,  'selected': classification.selected}">{{classification.count}}</td>
        </tr>
        <tr>
            <td class="hide"></td>
            <td class="hide"></td>
            <th ng-repeat="classification in $ctrl.matrix[0] track by $index">{{classification.consequence}}</th>
        </tr>
        <tr>
            <td class="hide"></td>
            <td class="hide"></td>
            <td colspan="{{$ctrl.config.ConsequenceMax - $ctrl.config.ConsequenceMin + 1}}" class="bottom-header" ng-bind-html="'matrix.Consequence'|translate"></td>
        </tr>
    </table>
</div>